import React, { useContext } from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Hidden from '@mui/material/Hidden';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { grey } from '@mui/material/colors';
import QRBarcodeArea from '../QRBarcodeArea';
import CodeGenerator from '../CodeGenerator';
import AppContext from '../../context/AppContext';
const Main = () => {
  const { data, setData } = useContext(AppContext);

  const { text } = data;

  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: grey[100],
        p: { xs: 2, sm: 2, md: 4, lg: 4, xl: 4 },
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Card>
            <CardContent>
              <Typography
                sx={{ fontSize: 14 }}
                color="text.secondary"
                gutterBottom
              >
                Data
              </Typography>
              <Stack direction="column" spacing={2}>
                <Stack direction="row">
                  {/* <Hidden>
                    <Button variant="contained" startIcon={<CloudUploadIcon />}>
                      Import from CSV
                    </Button>
                  </Hidden> */}
                </Stack>
                <Typography variant="body2" color="primary">
                  Enter Each Code in a New Line
                </Typography>
                <TextField
                  variant="filled"
                  placeholder="Enter QR/Barcodes"
                  multiline
                  autoComplete="off"
                  onChange={(e) => {
                    const itemsString = e.target.value;
                    // console.log(itemsString.split(/\r?\n/));
                    const items = itemsString.split(/\r?\n/).map((item) => {
                      return { value: item };
                    });
                    setData({ ...data, text: e.target.value, items });
                  }}
                  name="codeData"
                  value={text}
                  fullWidth
                  helperText={data.items.length}
                  rows={8}
                />
              </Stack>
            </CardContent>
          </Card>
          <Box sx={{ mt: 2 }}>
            <CodeGenerator />
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <QRBarcodeArea />
        </Grid>
      </Grid>
    </Box>
  );
};

export default Main;
